import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

interface Props {
  newspaperName: string;
  editionName: string;
  onVerify: (password: string) => Promise<boolean>;
}

export default function PasswordGate({ newspaperName, editionName, onVerify }: Props) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError(false);
    const ok = await onVerify(password);
    if (!ok) setError(true);
    setLoading(false);
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#faf7f0',
      px: 3,
    }}>
      <Typography sx={{
        fontFamily: '"Georgia", serif',
        fontWeight: 700,
        fontSize: '1.8rem',
        mb: 0.5,
      }}>
        {newspaperName}
      </Typography>
      <Typography sx={{ fontFamily: '"Georgia", serif', fontStyle: 'italic', color: '#666', mb: 3 }}>
        {editionName}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        This newspaper is password-protected.
      </Typography>
      <TextField
        type="password"
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={error}
        helperText={error ? 'Incorrect password' : ''}
        onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
        size="small"
        sx={{ mb: 2, width: 250 }}
      />
      <Button
        variant="contained"
        onClick={handleSubmit}
        disabled={loading || !password}
        sx={{ background: '#163567' }}
      >
        {loading ? 'Checking...' : 'Read newspaper'}
      </Button>
    </Box>
  );
}
